import angular from 'angular';

//TODO Use a factory to load weakMap or (local|session)storage
class CacheService {
    constructor() {
        //TODO use WeakMap
        this._wm = {};

        this.prefix = "st_";
        this.storage = localStorage;
        this.isLocalStorageActive = this.isLocalStorageSupported();
    }

    isLocalStorageSupported() {
        try {
            let testKey = 'test';
            this.storage.setItem(testKey, '1');
            this.storage.removeItem(testKey);
            return true;
        }
        catch (error) {
            return false;
        }
    }

    get(key) {
        let value = false;
        if (!this.isLocalStorageActive) {
            value = this._wm[key] || false;
            if (value) {
                value = angular.fromJson(value);
            }
            return value;
        }

        value = this.storage.getItem(key);
        if (!value) {
            return false;
        }

        return angular.fromJson(value);
    }

    set(key, value) {
        if (!this.isLocalStorageActive) {
            this._wm[key] = angular.toJson(value);
        }
        this.storage.setItem(key, angular.toJson(value));
    }

    delete(key) {
        if (!this.isLocalStorageActive) {
            delete this._wm[key];
        }
        this.storage.removeItem(key);
    }
    clear(){
        this.storage.clear();
    }
}

const cacheServiceModule = angular.module('st.services.cache', [])
    .service('cacheService', CacheService)
    .name;

export default cacheServiceModule;



// WEBPACK FOOTER //
// ./client/app/services/cache.service.js